import { render, staticRenderFns } from "./ParticipantPoliceStation.vue?vue&type=template&id=2d12cb3d"
import script from "./ParticipantPoliceStation.vue?vue&type=script&lang=js"
export * from "./ParticipantPoliceStation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports